export interface IGetFhirPatientDataRequest {
  patientIdentifier: string;
}
